import React from 'react';
import { AritoIcon } from '@/components/custom/arito';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface ActionsButtonProps {
  selectedSearchResult: any;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ActionsButton: React.FC<ActionsButtonProps> = ({ selectedSearchResult, onConfirm, onCancel }) => {
  return (
    <>
      <Button
        onClick={onConfirm}
        disabled={!selectedSearchResult}
        className={cn('h-9 min-w-16 bg-[#2563eb] px-4 py-1.5 text-white hover:bg-[#1d4ed8]', {
          'bg-gray-400 hover:bg-gray-400': !selectedSearchResult
        })}
      >
        <AritoIcon icon={884} className='mx-1' />
        Đồng ý
      </Button>
      <Button
        onClick={onCancel}
        variant='outline'
        className='h-9 min-w-16 border-transparent px-4 py-1.5 text-[#6b7280] hover:bg-[#f3f4f6] hover:text-[#6b7280]'
      >
        <AritoIcon icon={885} className='mx-1' />
        Hủy
      </Button>
    </>
  );
};
